﻿const TITLE_TAGS = Object.freeze({
    "/dc-power-distribution/optimum-value-gmt-fuse-panels": {
        title: Object.freeze({
            en: "Optimum Value GMT Fuse Panels",
            fr: "Panneaux de fusibles GMT à valeur optimale",
            es: "Paneles de fusibles GMT Optimum Value"
        }),
        descriptionId: 1
    },
    "/dc-power-distribution/optimum-value-breaker-panels": {
        title: Object.freeze({
            en: "Optimum Value Breaker Panels",
            fr: "Panneaux de disjoncteurs à valeur optimale",
            es: "Paneles de disyuntores Optimum Value"
        }),
        descriptionId: 2
    },
    "/dc-power-distribution/gmt-fuse-panels": {
        title: Object.freeze({
            en: "GMT Fuse Panels",
            fr: "Panneaux de fusibles GMT",
            es: "Paneles de fusibles GMT"
        }),
        descriptionId: 3
    },
    "/dc-power-distribution/klm-fuse-panels": {
        title: Object.freeze({
            en: "KLM Fuse Panels",
            fr: "Panneaux de fusibles KLM",
            es: "Paneles de fusibles KLM"
        }),
        descriptionId: 4
    },
    "/dc-power-distribution/tpa-fuse-panels": {
        title: Object.freeze({
            en: "TPA Fuse Panels",
            fr: "Panneaux de fusibles TPA",
            es: "Paneles de fusibles TPA"
        }),
        descriptionId: 5
    },
    "/dc-power-distribution/klmgmt-fuse-panels": {
        title: Object.freeze({
            en: "KLM GMT Fuse Panels",
            fr: "Panneaux de fusibles KLM GMT",
            es: "Paneles de fusibles KLM GMT"
        }),
        descriptionId: 6
    },
    "/dc-power-distribution/tpagmt-fuse-panels": {
        title: Object.freeze({
            en: "TPA GMT Fuse Panels",
            fr: "Panneaux de fusibles TPA GMT",
            es: "Paneles de fusibles TPA GMT"
        }),
        descriptionId: 7
    },
    "/dc-power-distribution/demarcation-panels": {
        title: Object.freeze({
            en: "Demarcation Panels",
            fr: "Panneaux de démarcation",
            es: "Paneles de demarcación"
        }),
        descriptionId: 8
    },
    "/dc-power-distribution/high-current-power-distribution-panels": {
        title: Object.freeze({
            en: "High Current Power Distribution Panels",
            fr: "Panneaux de distribution d’énergie à courant élevé",
            es: "Paneles de distribución de energía de alta corriente"
        }),
        descriptionId: 9
    },
    "/dc-power-distribution/total-front-access-fuse-panels": {
        title: Object.freeze({
            en: "Total Front Access Fuse Panels",
            fr: "Panneaux de fusibles à accès frontal total",
            es: "Paneles de fusibles de acceso frontal completo"
        }),
        descriptionId: 10
    },
    "/dc-power-distribution/total-front-access-combination-fuse-panels": {
        title: Object.freeze({
            en: "Total Front Access Combination Fuse Panels",
            fr: "Panneaux de fusibles combinés à accès frontal total",
            es: "Paneles de fusibles de combinación de acceso frontal total"
        }),
        descriptionId: 11
    },
    "/dc-power-distribution/versatile-fusebreaker-panels": {
        title: Object.freeze({
            en: "Versatile Fuse Breaker Panels",
            fr: "Panneaux de fusibles Disjoncteurs polyvalents",
            es: "Paneles de fusibles Disyuntores versátiles"
        }),
        descriptionId: 12
    },
    "/dc-power-distribution/collocation-interconnect-power-panels": {
        title: Object.freeze({
            en: "Collocation Interconnect Power Panels",
            fr: "Panneaux d'alimentation pour interconnexion en colocation",
            es: "Paneles de interconexión de energía"
        }),
        descriptionId: 13
    },
    "/dc-fuses-and-disconnects/gmt-fuses": {
        title: Object.freeze({
            en: "GMT Fuses | Bussmann",
            fr: "Fusibles GMT | Bussmann",
            es: "Fusibles GMT | Bussmann"
        }),
        descriptionId: 14
    },
    "/dc-fuses-and-disconnects/klm-fuses": {
        title: Object.freeze({
            en: "KLM Fuses | Eaton Bussmann",
            fr: "Fusibles KLM | Eaton Bussmann",
            es: "Fusibles KLM | Eaton Bussmann"
        }),
        descriptionId: 15
    },
    "/dc-fuses-and-disconnects/tpa-fuses": {
        title: Object.freeze({
            en: "TPA Fuses | Eaton Bussmann",
            fr: "Fusibles TPA | Eaton Bussmann",
            es: "Fusibles TPA | Eaton Bussmann"
        }),
        descriptionId: 16
    },
    "/dc-fuses-and-disconnects/tps-fuses": {
        title: Object.freeze({
            en: "TPS Fuses | Eaton Bussmann",
            fr: "Fusibles TPS | Eaton Bussmann",
            es: "Fusibles TPS | Eaton Bussmann"
        }),
        descriptionId: 17
    },
    "/dc-fuses-and-disconnects/tls-fuses": {
        title: Object.freeze({
            en: "TLS Fuses | Littelfuse",
            fr: "Fusibles TLS | Littelfuse",
            es: "Fusibles TLS | Littelfuse"
        }),
        descriptionId: 18
    },
    "/dc-fuses-and-disconnects/tpc-fuses": {
        title: Object.freeze({
            en: "TPC Fuses | Eaton Bussmann",
            fr: "Fusibles TPC | Eaton Bussmann",
            es: "Fusibles TPC | Eaton Bussmann"
        }),
        descriptionId: 19
    },
    "/dc-fuses-and-disconnects/tpl-fuses": {
        title: Object.freeze({
            en: "TPL Fuses | Eaton Bussmann",
            fr: "Fusibles TPL | Eaton Bussmann",
            es: "Fusibles TPL | Eaton Bussmann"
        }),
        descriptionId: 20
    },
    "/dc-fuses-and-disconnects/telecom-fused-disconnects": {
        title: Object.freeze({
            en: "Telecom Fused Disconnects | Canadian Shunt",
            fr: "Déconnexion à fusible de télécommunications | Canadian Shunt",
            es: "Desconexiones con fusibles para  telecomunicaciones | Canadian Shunt"
        }),
        descriptionId: 21
    },
    "/dc-fuses-and-disconnects/dummy-fusesblanking-plugs": {
        title: Object.freeze({
            en: "Dummy Fuses Blanking Plugs",
            fr: "Fusibles factices Bouchons d’obturation",
            es: "Fusibles falsos Enchufes ciegos"
        }),
        descriptionId: 22
    },
    "/dc-circuit-breakers/ov-breaker-panel-circuit-breakers": {
        title: Object.freeze({
            en: "OV Breaker Panel Circuit Breakers | Airpax",
            fr: "Disjoncteurs de panneau de disjoncteurs à valeur optimale | Airpax",
            es: "Disyuntores del panel de disyuntores OV | Airpax"
        }),
        descriptionId: 23
    },
    "/dc-circuit-breakers/single-pole-circuit-breakers": {
        title: Object.freeze({
            en: "Single Pole Circuit Breakers | Airpax",
            fr: "Disjoncteurs unipolaires | Airpax",
            es: "Disyuntores unipolares | Airpax"
        }),
        descriptionId: 24
    },
    "/dc-circuit-breakers/two-pole-circuit-breakers": {
        title: Object.freeze({
            en: "Two Pole Circuit Breakers | Airpax",
            fr: "Disjoncteurs bipolaires | Airpax",
            es: "Disyuntores bipolares | Airpax"
        }),
        descriptionId: 25
    },
    "/accessories/heat-baffles": {
        title: Object.freeze({
            en: "Heat Baffles",
            fr: "Déflecteurs thermiques",
            es: "Deflectores térmico"
        }),
        descriptionId: null
    },
    "/accessories/bridging-clips": {
        title: Object.freeze({
            en: "Bridging Clips",
            fr: "Clips de pontage",
            es: "Clips de puente"
        }),
        descriptionId: 26
    },
    "/accessories/rack-adapters": {
        title: Object.freeze({
            en: "Rack Adapters",
            fr: "Adaptateurs de rack",
            es: "Adaptadores de rack"
        }),
        descriptionId: 27
    },
    "/accessories/cable-management": {
        title: Object.freeze({
            en: "Cable Management",
            fr: "Gestion des câbles",
            es: "Gestión de cables"
        }),
        descriptionId: 28
    },
    "/about-us": {
        title: Object.freeze({
            en: "About",
            fr: "À propos de nous",
            es: "Sobre nosotros"
        }),
        descriptionId: 29
    },
    "/conflict-minerals-sourcing": {
        title: Object.freeze({
            en: "Conflict Mineral Sourcing",
            fr: "Conflict Mineral Sourcing",
            es: "Conflict Mineral Sourcing"
        }),
        descriptionId: 30
    },
    "/faqs": {
        title: Object.freeze({
            en: "FAQs",
            fr: "FAQs",
            es: "PREGUNTAS FRECUENTES"
        }),
        descriptionId: 31
    },
    "/installation-guides": {
        title: Object.freeze({
            en: "Installation Guides",
            fr: "Guide d'installation",
            es: "Guías de instalación"
        }),
        descriptionId: 32
    },
    "/contact-us": {
        title: Object.freeze({
            en: "Contact Us",
            fr: "Contactez-nous",
            es: "Póngase en contacto con nosotros"
        }),
        descriptionId: 33
    },
    "/blogs": {
        title: Object.freeze({
            en: "Blog",
            fr: "Blog",
            es: "Blog"
        }),
        descriptionId: 34
    },
    "/dc-power-distribution": {
        title: Object.freeze({
            en: "DC Power Distribution",
            fr: "Distribution d’énergie CC",
            es: "Distribución de energía de CC"
        }),
        descriptionId: null
    },
    "/dc-fuses-and-disconnects": {
        title: Object.freeze({
            en: "DC Fuses And Disconnects",
            fr: "Fusibles et connecteurs CC",
            es: "Fusibles y desconexiones de CC"
        }),
        descriptionId: null
    },
    "/dc-circuit-breakers": {
        title: Object.freeze({
            en: "DC Circuit Breakers",
            fr: "Disjoncteurs CC",
            es: "Disyuntores de CC"
        }),
        descriptionId: null
    },
    "/accessories": {
        title: Object.freeze({
            en: "Accessories",
            fr: "Accessoires",
            es: "Accesorios"
        }),
        descriptionId: null
    },
    "/": {
        title: Object.freeze({
            en: "DC Power Distribution Panels and Breakers",
            fr: "Panneaux et disjoncteurs de distribution d'alimentation CC",
            es: "Paneles de distribución de energía CC y disyuntores"
        }),
        descriptionId: 35
    },
    "/terms-of-use": {
        title: Object.freeze({
            en: "Terms of Use",
            fr: "Conditions d'utilisation",
            es: "Términos de uso"
        }),
        descriptionId: null
    },
    "/privacy-policy": {
        title: Object.freeze({
            en: "Privacy Policy",
            fr: "La politique de confidentialité",
            es: "La Política de privacidad"
        }),
        descriptionId: null
    },
    "/fuse-coverage": {
        title: Object.freeze({
            en: "Fuse Coverage",
            fr: "Couverture des fusibles",
            es: "Cobertura de fusible"
        }),
        descriptionId: null
    },
    "/circuit-breaker-coverage": {
        title: Object.freeze({
            en: "Circuit Breaker Coverage",
            fr: "Couverture des disjoncteurs",
            es: "Cobertura de interruptores automáticos"
        }),
        descriptionId: null
    },
});

const DESCRIPTION_TAGS = Object.freeze({
    1: Object.freeze({
        en: "Depend on Trimm's Optimum Value GMT Panels. Protection from .18 to 20 amps per position and up to 100 amps per bus.Contact Trimm today for a quote",
        fr: "Depend on Trimm's Optimum Value GMT Panels. Protection from .18 to 20 amps per position and up to 100 amps per bus.Contact Trimm today for a quote",
        es: "Depend on Trimm's Optimum Value GMT Panels. Protection from .18 to 20 amps per position and up to 100 amps per bus.Contact Trimm today for a quote"
    }),
    2: Object.freeze({
        en: "Optimum Value Breaker Panels that are compact, cost effective and lightweight with bus ratings up to 100 amps.Contact Trimm today for a quote",
        fr: "Optimum Value Breaker Panels that are compact, cost effective and lightweight with bus ratings up to 100 amps.Contact Trimm today for a quote",
        es: "Optimum Value Breaker Panels that are compact, cost effective and lightweight with bus ratings up to 100 amps.Contact Trimm today for a quote"
    }),
    3: Object.freeze({
        en: "Rely on the leader in TPA/GMT Panels. Up to 300 amps per bus with up to 50 amps per position.Contact Trimm today for a quote",
        fr: "Rely on the leader in TPA/GMT Panels. Up to 300 amps per bus with up to 50 amps per position.Contact Trimm today for a quote",
        es: "Rely on the leader in TPA/GMT Panels. Up to 300 amps per bus with up to 50 amps per position.Contact Trimm today for a quote"
    }),
    4: Object.freeze({
        en: "KLM Fuse Panels for medium loads at 100 amps per bus and up to 30 amps per position",
        fr: "KLM Fuse Panels for medium loads at 100 amps per bus and up to 30 amps per position",
        es: "KLM Fuse Panels for medium loads at 100 amps per bus and up to 30 amps per position"
    }),
    5: Object.freeze({
        en: "TPA Fuse Panels that protect 30 to 50 amps per position and up to 150 amps per side",
        fr: "TPA Fuse Panels that protect 30 to 50 amps per position and up to 150 amps per side",
        es: "TPA Fuse Panels that protect 30 to 50 amps per position and up to 150 amps per side"
    }),
    6: Object.freeze({
        en: "Certified to the high industry standards, rely on Trimm's combo KLM/GMT Panels. Up to 30 amp fuse positions and 150 amps per bus with multiple positions",
        fr: "Certified to the high industry standards, rely on Trimm's combo KLM/GMT Panels. Up to 30 amp fuse positions and 150 amps per bus with multiple positions",
        es: "Certified to the high industry standards, rely on Trimm's combo KLM/GMT Panels. Up to 30 amp fuse positions and 150 amps per bus with multiple positions"
    }),
    7: Object.freeze({
        en: "Rely on the leader in TPA/GMT Panels. Up to 300 amps per bus with up to 50 amps per position",
        fr: "Rely on the leader in TPA/GMT Panels. Up to 300 amps per bus with up to 50 amps per position",
        es: "Rely on the leader in TPA/GMT Panels. Up to 300 amps per bus with up to 50 amps per position"
    }),
    8: Object.freeze({
        en: "Demarcation/GMT Panels that are perfect for routers or switches. Bus rating up to 125 amps with positions ranging from 20 to 125 amps",
        fr: "Demarcation/GMT Panels that are perfect for routers or switches. Bus rating up to 125 amps with positions ranging from 20 to 125 amps",
        es: "Demarcation/GMT Panels that are perfect for routers or switches. Bus rating up to 125 amps with positions ranging from 20 to 125 amps"
    }),
    9: Object.freeze({
        en: "Gain the versatility of breakers, fuses and monitoring with High Current Power Distribution Panelsю Increase your capacity up to 600 amps per bus",
        fr: "Gain the versatility of breakers, fuses and monitoring with High Current Power Distribution Panelsю Increase your capacity up to 600 amps per bus",
        es: "Gain the versatility of breakers, fuses and monitoring with High Current Power Distribution Panelsю Increase your capacity up to 600 amps per bus"
    }),
    10: Object.freeze({
        en: "Maximize your choices with GMT or TPA fuses in Trimm's Total Front Access Panels.Bus ratings from 70 to 150 amps",
        fr: "Maximize your choices with GMT or TPA fuses in Trimm's Total Front Access Panels.Bus ratings from 70 to 150 amps",
        es: "Maximize your choices with GMT or TPA fuses in Trimm's Total Front Access Panels.Bus ratings from 70 to 150 amps"
    }),
    11: Object.freeze({
        en: "Total Front Access Combination Fuse Panels that you can depend on.Choose from KLM/ GMT or TPA / GMT fuses",
        fr: "Total Front Access Combination Fuse Panels that you can depend on.Choose from KLM/ GMT or TPA / GMT fuses",
        es: "Total Front Access Combination Fuse Panels that you can depend on.Choose from KLM/ GMT or TPA / GMT fuses"
    }),
    12: Object.freeze({
        en: "Versatile Fuse/Breaker Panels with the industry's best bus ratings of 425 amps or 850 amps",
        fr: "Versatile Fuse/Breaker Panels with the industry's best bus ratings of 425 amps or 850 amps",
        es: "Versatile Fuse/Breaker Panels with the industry's best bus ratings of 425 amps or 850 amps"
    }),
    13: Object.freeze({
        en: "Collocation Interconnect Power Panels with ratings up to 450 amps per bus and 450 amps per position",
        fr: "Collocation Interconnect Power Panels with ratings up to 450 amps per bus and 450 amps per position",
        es: "Collocation Interconnect Power Panels with ratings up to 450 amps per bus and 450 amps per position"
    }),
    14: Object.freeze({
        en: "GMT Fuses Bussmann. Ranging from .18 amps  to 20 amps for Smaller Loads. Accessories to Trimm's 757, 707 Series and all Combination Panels.",
        fr: "GMT Fuses Bussmann. Ranging from .18 amps  to 20 amps for Smaller Loads. Accessories to Trimm's 757, 707 Series and all Combination Panels.",
        es: "GMT Fuses Bussmann. Ranging from .18 amps  to 20 amps for Smaller Loads. Accessories to Trimm's 757, 707 Series and all Combination Panels."
    }),
    15: Object.freeze({
        en: "KLM Fuses Eaton Bussmann. Ranging from .10 amps to 30 amps for Intermediate DC Load Protection. Accessories to Trimm's 717 and 817 Series Panels.",
        fr: "KLM Fuses Eaton Bussmann. Ranging from .10 amps to 30 amps for Intermediate DC Load Protection. Accessories to Trimm's 717 and 817 Series Panels.",
        es: "KLM Fuses Eaton Bussmann. Ranging from .10 amps to 30 amps for Intermediate DC Load Protection. Accessories to Trimm's 717 and 817 Series Panels."
    }),
    16: Object.freeze({
        en: "TPA Fuses Eaton Bussmann. Ranging from 3 amps to 50 amps for a Wide Range of DC Protection. Accessories to Trimm's 737 and 827 Series Panels.",
        fr: "TPA Fuses Eaton Bussmann. Ranging from 3 amps to 50 amps for a Wide Range of DC Protection. Accessories to Trimm's 737 and 827 Series Panels.",
        es: "TPA Fuses Eaton Bussmann. Ranging from 3 amps to 50 amps for a Wide Range of DC Protection. Accessories to Trimm's 737 and 827 Series Panels."
    }),
    17: Object.freeze({
        en: "TPS Fuses Eaton Bussmann. Ranging from 1 amp to 70 amps.Accessories to Trimm's Versa-Slot Panels.",
        fr: "TPS Fuses Eaton Bussmann. Ranging from 1 amp to 70 amps.Accessories to Trimm's Versa-Slot Panels.",
        es: "TPS Fuses Eaton Bussmann. Ranging from 1 amp to 70 amps.Accessories to Trimm's Versa-Slot Panels."
    }),
    18: Object.freeze({
        en: "TLS Fuses Littelfuse Ranging from 1 amp to 125 amps. Accessories to Trimm's Versatile Series, High Current Power Distribution Panels, Demarcation Panels and Select OV Breaker Panels.",
        fr: "TLS Fuses Littelfuse Ranging from 1 amp to 125 amps. Accessories to Trimm's Versatile Series, High Current Power Distribution Panels, Demarcation Panels and Select OV Breaker Panels.",
        es: "TLS Fuses Littelfuse Ranging from 1 amp to 125 amps. Accessories to Trimm's Versatile Series, High Current Power Distribution Panels, Demarcation Panels and Select OV Breaker Panels."
    }),
    19: Object.freeze({
        en: "TPC Fuses Eaton Bussmann. Ranging from 3 amps to 125 amps. Accessories to Trimm's 767, 787 Series and Select 907 OV Breaker Panels with Versa-Slots.",
        fr: "TPC Fuses Eaton Bussmann. Ranging from 3 amps to 125 amps. Accessories to Trimm's 767, 787 Series and Select 907 OV Breaker Panels with Versa-Slots.",
        es: "TPC Fuses Eaton Bussmann. Ranging from 3 amps to 125 amps. Accessories to Trimm's 767, 787 Series and Select 907 OV Breaker Panels with Versa-Slots."
    }),
    20: Object.freeze({
        en: "TPL Fuses Eaton Bussmann. Ranging from 70 amps to 800 amps for Higher Interruption Ratings. Accessories to Trimm's 937 Series and Colocation Interconnect Panels.",
        fr: "TPL Fuses Eaton Bussmann. Ranging from 70 amps to 800 amps for Higher Interruption Ratings. Accessories to Trimm's 937 Series and Colocation Interconnect Panels.",
        es: "TPL Fuses Eaton Bussmann. Ranging from 70 amps to 800 amps for Higher Interruption Ratings. Accessories to Trimm's 937 Series and Colocation Interconnect Panels."
    }),
    21: Object.freeze({
        en: "Get the Right Disconnects Canadian Shunt for your Trimm Panel. Used in Trimm's 907, 767 and 787 Series Panels.",
        fr: "Get the Right Disconnects Canadian Shunt for your Trimm Panel. Used in Trimm's 907, 767 and 787 Series Panels.",
        es: "Get the Right Disconnects Canadian Shunt for your Trimm Panel. Used in Trimm's 907, 767 and 787 Series Panels."
    }),
    22: Object.freeze({
        en: "Fill Unused GMT, KLM, Optimum Value, Single Pole and Two Pole Breaker Positions with Dummy Fuses or Blanking Plugs.",
        fr: "Fill Unused GMT, KLM, Optimum Value, Single Pole and Two Pole Breaker Positions with Dummy Fuses or Blanking Plugs.",
        es: "Fill Unused GMT, KLM, Optimum Value, Single Pole and Two Pole Breaker Positions with Dummy Fuses or Blanking Plugs."
    }),
    23: Object.freeze({
        en: "Sensata Airpax Snapak circuit breaker panels assure immediate opening and closing of the contacts increasing the reliability. Ranging from .50 amps to 30 amps for Optimum Value Panels. Accessories to Trimm's 907 Series Panels.",
        fr: "Sensata Airpax Snapak circuit breaker panels assure immediate opening and closing of the contacts increasing the reliability. Ranging from .50 amps to 30 amps for Optimum Value Panels. Accessories to Trimm's 907 Series Panels.",
        es: "Sensata Airpax Snapak circuit breaker panels assure immediate opening and closing of the contacts increasing the reliability. Ranging from .50 amps to 30 amps for Optimum Value Panels. Accessories to Trimm's 907 Series Panels."
    }),
    24: Object.freeze({
        en: "Sensata Airpax hydraulic magnetic circuit breakers provide reliable and accurate circuit protection. Ranging from 5 amps to 100 amps for Versa-Slot Panels. Accessories to Trimm's 867, 787, and Select 907 Series Panels.",
        fr: "Sensata Airpax hydraulic magnetic circuit breakers provide reliable and accurate circuit protection. Ranging from 5 amps to 100 amps for Versa-Slot Panels. Accessories to Trimm's 867, 787, and Select 907 Series Panels.",
        es: "Sensata Airpax hydraulic magnetic circuit breakers provide reliable and accurate circuit protection. Ranging from 5 amps to 100 amps for Versa-Slot Panels. Accessories to Trimm's 867, 787, and Select 907 Series Panels."
    }),
    25: Object.freeze({
        en: "Sensata Airpax breakers protect high powered circuits in a small space. Ranging from 110 amps to 150 amps for Versa - Slot Panels. Accessories to Trimm's 907 and 787 Series Panels.",
        fr: "Sensata Airpax breakers protect high powered circuits in a small space. Ranging from 110 amps to 150 amps for Versa - Slot Panels. Accessories to Trimm's 907 and 787 Series Panels.",
        es: "Sensata Airpax breakers protect high powered circuits in a small space. Ranging from 110 amps to 150 amps for Versa - Slot Panels. Accessories to Trimm's 907 and 787 Series Panels."
    }),
    26: Object.freeze({
        en: "Bridging clip kits for grouping individual inputs on Trimm 927 Series Demarcation Panels.  Call Trimm Today to get started.",
        fr: "Bridging clip kits for grouping individual inputs on Trimm 927 Series Demarcation Panels.  Call Trimm Today to get started.",
        es: "Bridging clip kits for grouping individual inputs on Trimm 927 Series Demarcation Panels.  Call Trimm Today to get started."
    }),
    27: Object.freeze({
        en: "Expand Your OV panels for 23' Applications.19' to 23' Adapters, OV series of panels.Get these for your 23' frames.Call Trimm Today to get started.",
        fr: "Expand Your OV panels for 23' Applications.19' to 23' Adapters, OV series of panels.Get these for your 23' frames.Call Trimm Today to get started.",
        es: "Expand Your OV panels for 23' Applications.19' to 23' Adapters, OV series of panels.Get these for your 23' frames.Call Trimm Today to get started."
    }),
    28: Object.freeze({
        en: "Cable management kits for wire support on various Trimm products. Call Trimm Today for more information.",
        fr: "Cable management kits for wire support on various Trimm products. Call Trimm Today for more information.",
        es: "Cable management kits for wire support on various Trimm products. Call Trimm Today for more information."
    }),
    29: Object.freeze({
        en: "Trimm, Inc. is a a leading manufacturer of premium quality  DC power distrubution with over 100 years of experience As a committed manufacturer and technical leader, Trimm continues to innovate and develop new products, while maintaining a commitment to excellence and value in our products.",
        fr: "Trimm, Inc. is a a leading manufacturer of premium quality  DC power distrubution with over 100 years of experience As a committed manufacturer and technical leader, Trimm continues to innovate and develop new products, while maintaining a commitment to excellence and value in our products.",
        es: "Trimm, Inc. is a a leading manufacturer of premium quality  DC power distrubution with over 100 years of experience As a committed manufacturer and technical leader, Trimm continues to innovate and develop new products, while maintaining a commitment to excellence and value in our products."
    }),
    30: Object.freeze({
        en: "Our Conflict Minerals Sourcing Policy page outlines our commitment to responsible mineral sourcing and our efforts to avoid the use of conflict minerals in our products.Learn more about our policies and practices",
        fr: "Our Conflict Minerals Sourcing Policy page outlines our commitment to responsible mineral sourcing and our efforts to avoid the use of conflict minerals in our products.Learn more about our policies and practices",
        es: "Our Conflict Minerals Sourcing Policy page outlines our commitment to responsible mineral sourcing and our efforts to avoid the use of conflict minerals in our products.Learn more about our policies and practices"
    }),
    31: Object.freeze({
        en: "Trimm's FAQ page provides answers to common questions about our products and services. Get the information you need to make informed decisions. Check it out today.",
        fr: "Trimm's FAQ page provides answers to common questions about our products and services. Get the information you need to make informed decisions. Check it out today.",
        es: "Trimm's FAQ page provides answers to common questions about our products and services. Get the information you need to make informed decisions. Check it out today."
    }),
    32: Object.freeze({
        en: "Check Trimm's Installation Guides. A Series represents multiple part numbers.  If a part number is listed , it will have an individual guide and is not part of a series",
        fr: "Check Trimm's Installation Guides. A Series represents multiple part numbers.  If a part number is listed , it will have an individual guide and is not part of a series",
        es: "Check Trimm's Installation Guides. A Series represents multiple part numbers.  If a part number is listed , it will have an individual guide and is not part of a series"
    }),
    33: Object.freeze({
        en: "Looking for reliable power distribution solutions for your DC power systems? Contact Trimm today. We offer a wide range of high-quality fuses, breakers, and disconnects for our panels, along with dummy fuses and blanking plugs to fill unused positions. Our experienced team can help you find the perfect solution for your power management needs.",
        fr: "Looking for reliable power distribution solutions for your DC power systems? Contact Trimm today. We offer a wide range of high-quality fuses, breakers, and disconnects for our panels, along with dummy fuses and blanking plugs to fill unused positions. Our experienced team can help you find the perfect solution for your power management needs.",
        es: "Looking for reliable power distribution solutions for your DC power systems? Contact Trimm today. We offer a wide range of high-quality fuses, breakers, and disconnects for our panels, along with dummy fuses and blanking plugs to fill unused positions. Our experienced team can help you find the perfect solution for your power management needs.",
    }),
    34: Object.freeze({
        en: "Trimm's blog page features informative articles and insights on the latest industry trends, updates on Trimm's products and services, and helpful tips for power management solutions.",
        fr: "Trimm's blog page features informative articles and insights on the latest industry trends, updates on Trimm's products and services, and helpful tips for power management solutions.",
        es: "Trimm's blog page features informative articles and insights on the latest industry trends, updates on Trimm's products and services, and helpful tips for power management solutions."
    }),
    35: Object.freeze({
        en: "Trimm's Reliable DC Powered Fuse and Breaker Panels for Proven Results.Offering a Selection of Heat Baffles, Bridging Clips, Rack Adapters and Cable Management Solutions.",
        fr: "Trimm's Reliable DC Powered Fuse and Breaker Panels for Proven Results.Offering a Selection of Heat Baffles, Bridging Clips, Rack Adapters and Cable Management Solutions.",
        es: "Trimm's Reliable DC Powered Fuse and Breaker Panels for Proven Results.Offering a Selection of Heat Baffles, Bridging Clips, Rack Adapters and Cable Management Solutions."
    })
});

export {
    TITLE_TAGS,
    DESCRIPTION_TAGS
};